import React from "react";
import { Skeleton, Card, Divider, Row, Col, Space, Typography } from "antd";

const { Title, Text } = Typography;

const SubscriptionSkeleton = () => {
  return (
    <div
      style={{
        paddingTop: "90px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%"
      }}
    >
      <div style={{ maxWidth: "800px", width: "100%", margin: "0 auto" }}>
        <div style={{ textAlign: "center" }}>
          <Title level={2} style={{ margin: "0", color: "#333" }}>
            <Skeleton.Input style={{ width: 250 }} active size="large" />
          </Title>
        </div>

        <Card
          style={{
            width: "100%",
            padding: "30px",
            borderRadius: "12px",
            backgroundColor: "#fff",
            marginTop: "30px",
          }}
        >
          <Title
            level={3}
            style={{
              textAlign: "center",
              marginBottom: "25px",
              color: "#282828",
            }}
          >
            <Skeleton.Input style={{ width: 200 }} active size="default" />
          </Title>

          <Row gutter={[16, 16]}>
            {Array.from({ length: 6 }).map((_, index) => (
              <Col xs={24} sm={12} key={index}>
                <Space direction="vertical" style={{ width: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <Skeleton.Avatar
                      shape="circle"
                      size="default"
                      active
                      style={{ marginRight: "10px" }}
                    />
                    <div style={{ flexGrow: 1 }}>
                      <Skeleton.Input
                        style={{ width: "80%" }}
                        active
                        size="small"
                      />
                      <Skeleton.Input
                        style={{ width: "60%", marginTop: 5 }}
                        active
                        size="small"
                      />
                    </div>
                  </div>
                </Space>
              </Col>
            ))}
          </Row>

          <Divider style={{ margin: "25px 0" }} />

          <div style={{ textAlign: "center" }}>
            <Text type="secondary">
              <Skeleton.Input style={{ width: "70%" }} active size="small" />
            </Text>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default SubscriptionSkeleton;
